import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class NutritionDataTable extends PureComponent {
  static propTypes = {
    nutritionData: PropTypes.array,
  };

  state = {};

  componentDidMount = () => {
    this.cloneTableIfNeeded();
    window.addEventListener('resize', this.cloneTableIfNeeded);
  };

  componentWillUnmount = () => {
    const currentElement = this.nutritionDataWrapper && this.nutritionDataWrapper.current;
    if (currentElement && typeof currentElement.removeEventListener === 'function') {
      currentElement.removeEventListener('scroll', this.isCheckTableScroll);
    }
    window.removeEventListener('resize', this.cloneTableIfNeeded);
  };

  isCheckTableScroll = (e) => {
    this.setState({ isScrolled: e.srcElement.scrollLeft > 0 });
  };

  cloneTableIfNeeded = () => {
    const currentElement = this.nutritionDataWrapper && this.nutritionDataWrapper.current;
    const nutritionTableHtmlElement = currentElement && currentElement.getElementsByTagName('table');
    if (nutritionTableHtmlElement && nutritionTableHtmlElement.length > 0) {
      const elementWidth = nutritionTableHtmlElement[0].getBoundingClientRect().width;
      const parentWidth = currentElement && currentElement.parentElement.getBoundingClientRect().width;

      if (currentElement && elementWidth > parentWidth) {
        this.setState({ nutritionDataCloneNeeded: true });
        currentElement.addEventListener('scroll', this.isCheckTableScroll);
      }
    }
  };

  nutritionDataWrapper = React.createRef();

  render() {
    const { nutritionData } = this.props;

    const [{ content } = {}] = nutritionData;

    if (content) {
      return (
        <div className="bop-nutritionData">
          <div className="bop-nutritionData__wrapper">
            <div
              className={
                `bop-nutritionData__origin ${this.state.isScrolled ? 'bop-nutritionData__origin--isScrolled' : ''}`}
              dangerouslySetInnerHTML={{ __html: content }}
              ref={this.nutritionDataWrapper}
            />
            {this.state.nutritionDataCloneNeeded && (
              <div
                className="bop-nutritionData__clone"
                dangerouslySetInnerHTML={{ __html: content }}
              />)}
          </div>
        </div>
      );
    }

    return null;
  }
}
